import React from 'react';
import { MLOutcome } from '../../data/industryData';
import '../../styles/MLOutcomes.css';

interface MLOutcomesProps {
  outcomes: MLOutcome[];
}

const MLOutcomes: React.FC<MLOutcomesProps> = ({ outcomes }) => {
  return (
    <div className="ml-outcomes-section">
      <div className="ml-outcomes-container">
        <h2 className="ml-outcomes-title">Real-World ML/AI Project Outcomes</h2>
        <p className="ml-outcomes-subtitle">
          We've delivered tangible results for AI-first companies facing complex infrastructure challenges
        </p>
        
        <div className="ml-outcomes-grid">
          {outcomes.map((outcome, index) => (
            <div className="ml-outcome-card" key={index}>
              <div className="ml-outcome-header">
                <div className="ml-outcome-emoji">{outcome.emoji || "🚀"}</div>
                <h3 className="ml-outcome-title">{outcome.title}</h3>
              </div>
              
              <div className="ml-outcome-content">
                <div className="ml-outcome-row">
                  <h4>Challenge:</h4>
                  <p>{outcome.challenge}</p>
                </div>
                
                <div className="ml-outcome-row">
                  <h4>Solution:</h4>
                  <p>{outcome.solution}</p>
                </div>
                
                <div className="ml-outcome-row">
                  <h4>Impact:</h4>
                  <p>{outcome.impact}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MLOutcomes; 